import React from "react";
import moment from "moment";
import { Global } from "@emotion/react";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import AdapterMomentJS from "@date-io/moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import GlobalFonts from "fonts/fonts";

import IntlWrapper from "components/IntlWrapper";

import { applicationStore, persistor, routerHistory } from "./store";
import ParkkiMuiTheme from "themes/parkkiMuiTheme";

import Router from "routes/router";
import routes from "routes/routes";

class App extends React.PureComponent {
  render() {
    return (
      <ThemeProvider theme={ParkkiMuiTheme}>
        <StyledEngineProvider injectFirst>
          <Provider store={applicationStore}>
            <PersistGate persistor={persistor}>
              <IntlWrapper>
                <LocalizationProvider
                  dateAdapter={AdapterMomentJS}
                  dateLibInstance={moment}
                >
                  <Global styles={GlobalFonts} />
                  <div style={{ height: "100%" }}>
                    <Router routerHistory={routerHistory} routes={routes} />
                    <ToastContainer hideProgressBar autoClose={8000} />
                  </div>
                </LocalizationProvider>
              </IntlWrapper>
            </PersistGate>
          </Provider>
        </StyledEngineProvider>
      </ThemeProvider>
    );
  }
}

export default App;
